<template lang="pug">
b-modal#editOperator(
  ref="editOperator"
  :title="$t('ui.combine.edit_account')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$t('ui.login_id')" disabled).mb-0
      DebounceInput(
        size="sm"
        ref="login_id"
        required
        alphaNum
        type="text"
        :dirty="$v.login_id.$dirty"
        :error="$v.login_id.$error"
        v-model.trim.lazy="$v.login_id.$model"
        :disabled="loading"
        :maxLength="$v.login_id.$params.maxLength.max"
      )
      ValidateResult(:value="$v.login_id" :name="$t('ui.login_id')")
    b-form-group(:label="$t('ui.full_name')").mb-0
      DebounceInput(
        size="sm"
        ref="full_name"
        type="text"
        :dirty="$v.full_name.$dirty"
        :error="$v.full_name.$error"
        v-model.trim.lazy="$v.full_name.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.full_name" :name="$t('ui.full_name')")
    b-form-group(:label="$t('ui.contact_phone')").mb-0
      DebounceInput(
        size="sm"
        numeric
        type="text"
        :dirty="$v.contact_phone.$dirty"
        :error="$v.contact_phone.$error"
        v-model.trim.lazy="$v.contact_phone.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.contact_phone" :name="$t('ui.contact_phone')")
    b-form-group(:label="$t('ui.contact_email')").mb-0
      DebounceInput(
        size="sm"
        email
        type="text"
        :dirty="$v.contact_email.$dirty"
        :error="$v.contact_email.$error"
        v-model.trim.lazy="$v.contact_email.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.contact_email" :name="$t('ui.contact_email')")
    //- div.row
    //-   div.col
    //-     b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, email, sameAs, helpers } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
const containAlphaNum = helpers.regex("containAlphaNum", /^(?=.*\d)(?=.*[a-zA-Z])/);
const alphaNumWithSpace = helpers.regex("alphaNumWithSpace", /^[a-z\d\-_\s]+$/i);

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      login_id: "",
      full_name: "",
      contact_phone: "",
      contact_email: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: {
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    }
  },
  validations: {
    login_id: {
      required,
      alphaNum,
      minLength: minLength(6),
      maxLength: maxLength(20)
    },
    full_name: {
      alphaNumWithSpace
    },
    contact_phone: {
      integer
    },
    contact_email: {
      email
    },
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.accountEditUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          login_id: this.login_id,
          full_name: this.full_name,
          contact_phone: this.contact_phone,
          contact_email: this.contact_email,
          audit_by: this.$store.getters.loginId
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  let json = {
                    login_id: this.login_id,
                    full_name: this.full_name,
                    contact_phone: this.contact_phone,
                    contact_email: this.contact_email
                  };
                  this.$emit("clicked", json);
                  this.$refs.editOperator.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "edit_operator", this.feedback.status);
                  this.$refs.editOperator.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.login_id = this.item.account_id;
      this.full_name = this.item.full_name;
      this.contact_phone = this.item.contact_phone;
      this.contact_email = this.item.contact_email;
      this.$refs.full_name.$el.focus();
    }
  }
};
</script>
